export const API_ENDPOINTS = {
  LOGIN: '/login',
  REGISTER: '/register',
  LOGOUT: '/logout',
  FORGET_PASSWORD: '/forget-password',
  CATEGORIES: '/categories',
  CATEGORY: (slug: string) => `/categories/${slug}`,
  DIETARY: '/dietary.json',
  BRANDS: '/products/brands',
  ALL_BRANDS: '/brands',
  BRAND: (slug: string) => `/brands/${slug}`,
  PRODUCTS: '/offers',
  PRODUCT: (id: string) => `/offers/${id}`,
  FLASH_SELL_PRODUCTS: '/products_flash_sell.json',
  BEST_SELLER_PRODUCTS: '/products_best_seller.json',
  BEST_SELLER_GROCERY_PRODUCTS: '/products_best_seller_grocery.json',
  POPULAR_PRODUCTS: '/products_popular.json',
  COOKIES_PRODUCTS: '/products_cookies.json',
  CHIPS_PRODUCTS: '/products_chips.json',
  FRESH_VEGETABLES_PRODUCTS: '/products_fresh_vegetables.json',
  SEARCH: '/products/search',
  CONTACT: '/contact.json',
  SHOP: '/shop.json',
  SHOPS: '/shops.json',
  PRODUCT_DETAIL: '/product/detail',
};
